import reportApis from '@landingPage/apis/report.api';
import { awaitWrap } from '@utils/common.util';
interface Timerange {
    timeType: string;
    lastDays?: number;
    lastDaysIncludeToday?: boolean;
    startTime?: number | string;
    endTime?: number | string;
}

interface State {
    assetsCount: number | null;
    timerange: Timerange | null;
    // currentSelectConversionId: [string] | null;
    currentSelectConversionName: string | null;
}

const state: State = {
    assetsCount: null,
    timerange: null,
    // currentSelectConversionId: null,
    currentSelectConversionName: null
};

export default {
    namespaced: true,
    state,
    getters: {
        timerange: (state: State) => state.timerange
    },
    mutations: {
        setAssetsCount(state: State, count: number) {
            state.assetsCount = count;
        },
        setPageTimerange(state: State, timerange: Timerange) {
            state.timerange = timerange;
        },
        // setCurrentSelectConversionId(state: State, id: [string]) {
        //     state.currentSelectConversionId = id;
        // },
        setCurrentSelectConversionName(state: State, name: string) {
            state.currentSelectConversionName = name;
        }
    },
    actions: {
        async updateAssetsCount(context: any, revalidate = false) {
            if (context.state.assetsCount !== null && !revalidate) return context.state.assetsCount;
            const [err, res] = await awaitWrap(reportApis.getAssetsCount());
            if (err) return Promise.reject(err);
            context.commit('setAssetsCount', res);
            return Promise.resolve(res);
        }
    }
};
